module.exports = "../fonts/facebook_authorize.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/facebook_authorize.svg
// module id = 216
// module chunks = 0